import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from 'src/app/services/common/log.service';
import { UserService } from 'src/app/services/user/user.service';
import { RegistrationSource, User } from 'src/app/interfaces/user';
import { environment } from 'src/environments/environment';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { Router } from '@angular/router';
import { ConfigService } from '../../services/config/config.service';

@Component({
  selector: 'app-pet-rehome-permission-request-modal',
  templateUrl: './pet-rehome-permission-request-modal.component.html',
  styleUrls: ['./pet-rehome-permission-request-modal.component.scss'],
})
export class PetRehomePermissionRequestModalComponent implements OnInit{
  @Input('modalRef') public modalRef: NgbModalRef;
  @Input('user') public user: User;
  @Input('chipNumber') public chipNumber: string;
  @Input('vetCode') public vetCode: string;

  public submissionComplete = false;
  public stripeDetailsLoading: boolean = false;
  public isPaymentFinished: boolean = false;
  public acceptTerms: boolean = false;
  public pricingPlans = environment.stripePlans;
  public planIdTOKPlusAlertFirstYear = this.pricingPlans.identiAlertTok;
  public brandName = '';
  public packageName = '';
  public extraPermissionText = '';

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private router: Router,
    private _logService: LogService,
    private checkoutService: CheckoutService,
    private configService: ConfigService
  ) {
    this.brandName = this.configService.getTextFromKey('brand-name');
    this.packageName = this.configService.getTextFromKey('2-plan-name');
    this.extraPermissionText = this.configService.getTextFromKey('extra-tok-permission-text');
  }

  ngOnInit(): void {
    if (this.user.registrationSource === RegistrationSource.PmsImportAT || this.user.registrationSource === RegistrationSource.VetXmlFromAT) {
      this.planIdTOKPlusAlertFirstYear = this.pricingPlans.atIdentiAlertTok;
    }
  }

  public confirmAndProceedToCheckout() {
    this.stripeDetailsLoading = true;
    if (this.userService.isTOKFreeForUser(this.user)) {
      this.router.navigate(['/rehome-pet'], { queryParams: { chipNumber: this.chipNumber, vetCode: this.vetCode } });
      this.modalRef.close();
      return;
    }

    this.checkoutService
      .checkout(
        [this.planIdTOKPlusAlertFirstYear],
        {
          vetCode: this.vetCode,
          chipNumber: this.chipNumber
        }
      )
      .subscribe({
        next: () => {
          // Nothing should happen here because if checkout gets completed successfully, a redirect
          // will be triggered by stripe checkout
        },
        error: (err) => {
          this.stripeDetailsLoading = false;
          this.modalRef.dismiss();
          this._logService.error('An error occurred', err);
        }
      })
      .add(() => {
        this.stripeDetailsLoading = false;
        this.modalRef.close();
      });
  }
}
